import { Link } from 'react-router-dom';

import { useTranslation } from '@/app/providers';
import { ROUTES } from '@/app/router/route-constants';
import { useAppSelector } from '@/app/store/hooks';
import { selectIsAuthenticated } from '@/features/auth/store/auth-slice';
import { Button } from '@/shared/components/button';
import { NotFoundState } from '@/shared/components/not-found-state';
import { useDocumentTitle } from '@/shared/hooks/use-document-title';

export function NotFoundPage() {
  const { t } = useTranslation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  useDocumentTitle(t('errors.pageNotFound'));

  return (
    <NotFoundState
      code="404"
      title={t('errors.pageNotFound')}
      description={t('errors.pageNotFoundDesc')}
      hint={isAuthenticated ? undefined : t('errors.publicHint')}
      actions={
        isAuthenticated ? (
          <Link to={ROUTES.DASHBOARD}>
            <Button size="lg">{t('errors.backToDashboard')}</Button>
          </Link>
        ) : (
          <Link to={ROUTES.HOME}>
            <Button size="lg">{t('errors.backToHome')}</Button>
          </Link>
        )
      }
    />
  );
}
